import React, { useState } from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Line,
    LineChart,
    ReferenceLine,
} from "recharts";

export default function FleetOwnersEarningChart() {
    const [period, setPeriod] = useState("Month");

    // Dummy datasets
    const dataSets = {
        Day: [
            { name: "Mon", earning: 200 },
            { name: "Tue", earning: 350 },
            { name: "Wed", earning: 300 },
            { name: "Thu", earning: 450 },
            { name: "Fri", earning: 400 },
            { name: "Sat", earning: 320 },
            { name: "Sun", earning: 280 },
        ],
        Week: [
            { name: "Week 1", earning: 1200 },
            { name: "Week 2", earning: 1600 },
            { name: "Week 3", earning: 900 },
            { name: "Week 4", earning: 1400 },
        ],
        Month: [
            { name: "Jan", earning: 2000 },
            { name: "Feb", earning: 3000 },
            { name: "Mar", earning: 1000 },
            { name: "Apr", earning: 2000 },
            { name: "May", earning: 4000 },
            { name: "Jun", earning: 1500 },
            { name: "Jul", earning: 3500 },
            { name: "Aug", earning: 3000 },
            { name: "Sep", earning: 1000 },
            { name: "Oct", earning: 4000 },
            { name: "Nov", earning: 2000 },
            { name: "Dec", earning: 2000 },
        ],
        Year: [
            { name: "2020", earning: 24000 },
            { name: "2021", earning: 32000 },
            { name: "2022", earning: 28000 },
            { name: "2023", earning: 40000 },
            { name: "2024", earning: 36500 },
        ],
    };



    const data = dataSets[period];
    const totalEarning = data.reduce((acc, cur) => acc + cur.earning, 0).toLocaleString();


    const tabContainerStyle = {
        display: "flex",
        alignItems: "center",
        background: "#f8f8ff",
        padding: "6px",
        borderRadius: "8px",
        gap: "4px",
    };

    const pillStyle = (active) => ({
        padding: "6px 12px",
        borderRadius: "8px",
        cursor: "pointer",
        background: active ? "#0064CF" : "transparent",
        color: active ? "#fff" : "#9291A5",
        border: "none",
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.2s ease",
    });

    return (
        <div className="w-100 p-4">
            <div className="w-100 rounded-2 border p-3" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div className="w-100 d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h6 className="text-muted mb-1 fs-5">Total Earning</h6>
                        <h4 className="fw-bold fs-2">{totalEarning}</h4>
                    </div>

                    <div style={tabContainerStyle}>
                        {["Day", "Week", "Month", "Year"].map((label) => (
                            <button
                                key={label}
                                style={pillStyle(period === label)}
                                onClick={() => setPeriod(label)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                    <AreaChart
                        data={data}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                        <defs>
                            <linearGradient id="colorEarning" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <ReferenceLine y={2400} stroke="#2B4BFF" strokeDasharray="3 6" strokeOpacity={0.25} />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Area
                            type="monotone"
                            dataKey="earning"
                            stroke="#3b82f6"
                            fillOpacity={1}
                            fill="url(#colorEarning)"
                            activeDot={{ r: 6 }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
